import React from "react";
import PropTypes from "prop-types";
import { Col, Container, Row, ListGroup } from "react-bootstrap";
import { connect } from "react-redux";

import { PLAN_CURRENCY } from "../../constants";
import { SELECTED_PLAN } from "../../actions/ActionTypes";
import RippleButton from "./RippleButton";

const scheduleDescription = [
  "No app to download",
  "No hardware",
  "QR Codes with your logo",
  "ADA compliant",
  "Mobile Responsive",
  "Easy to use",
  "QR Codes with images",
  "Multi users",
  "Multi venues",
  "Data integrations",
  "Customizations",
  "Email support",
];

const Plan = ({
  name,
  id,
  price,
  pricePerMonth,
  pricePerYear,
  description,
  onBuyNow,
  interval,
}) => {
  const handleBuyNow = () => onBuyNow({ id, price, interval });

  return (
    <Col lg={4} className="onboarding-plan-column">
      <div className="onboarding-plan-container">
        <p className="onboarding-plan-name">{name}</p>
        <p className="onboarding-plan-detail">
          <span className="onboarding-plan-currency">
            {PLAN_CURRENCY[pricePerMonth.currency]}
          </span>
          <span className="onboarding-plan-price">{pricePerMonth.amount}</span>
          <span className="onboarding-plan-interval"> / month</span>
        </p>
        <p className="onboarding-price-year">
          {PLAN_CURRENCY[pricePerYear.currency]}
          {pricePerYear.amount} Annually
        </p>
        <RippleButton customStyles="w-100" onClick={handleBuyNow}>
          Buy Now
        </RippleButton>
        <ListGroup className="p-3">
          {description.map((item, index) => (
            <ListGroup.Item
              className="border-0 px-0 py-2 d-flex align-items-center onboarding-item"
              key={`name-description-${index}`}
            >
              <span className="onboarding-item-dot" />
              {item}
            </ListGroup.Item>
          ))}
        </ListGroup>
      </div>
    </Col>
  );
};

const ListPlans = ({ plans = [], dispatch, history }) => {
  const handleBuyNow = (plan) => {
    dispatch({
      type: SELECTED_PLAN,
      payload: plan,
    });
    history.push("/onboarding");
  };

  return (
    <Container className="onboarding-plan">
      {plans.length ? (
        <Row>
          {plans.map(
            ({
              name,
              id,
              pricePerMonth,
              pricePerYear,
              description,
              price,
              interval,
            }) => (
              <Plan
                name={name}
                id={id}
                key={id}
                pricePerMonth={pricePerMonth}
                pricePerYear={pricePerYear}
                description={description}
                onBuyNow={handleBuyNow}
                price={price}
                interval={interval}
              />
            )
          )}
          <Col lg={4} className="onboarding-plan-column">
            <div className="onboarding-plan-container">
              <p className="onboarding-plan-name">Enterprise</p>
              <p className="onboarding-schedule-plan">
                Schedule a call for more info
              </p>
              <RippleButton
                customStyles="w-100 px-5"
                href="https://www.sproutqr.com/book-a-demo"
              >
                Schedule a call
              </RippleButton>
              <ListGroup className="p-3">
                {scheduleDescription.map((item, index) => (
                  <ListGroup.Item
                    className="border-0 px-0 py-2 d-flex align-items-center onboarding-item"
                    key={`schedule-description-${index}`}
                  >
                    <span className="onboarding-item-dot" />
                    {item}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
          </Col>
        </Row>
      ) : null}
    </Container>
  );
};

Plan.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  interval: PropTypes.string.isRequired,
  price: PropTypes.object.isRequired,
  pricePerMonth: PropTypes.object.isRequired,
  pricePerYear: PropTypes.object.isRequired,
  description: PropTypes.array.isRequired,
  onBuyNow: PropTypes.func.isRequired,
};

ListPlans.propTypes = {
  plans: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const { plan } = state;

  return {
    plans: plan.plans,
  };
};

export default connect(mapStateToProps)(ListPlans);
